const LastEducationDefiner = (val: any) => {
  let definedData = null
  switch (val) {
    case 'NoFormalEducation':
      definedData = { label: 'Tidak Sekolah', value: 'NoFormalEducation' }
      break
    case 'ElementarySchool':
      definedData = { label: 'SD', value: 'ElementarySchool' }
      break
    case 'JuniorHighSchool':
      definedData = { label: 'SMP', value: 'JuniorHighSchool' }
      break
    case 'SeniorHighSchool':
      definedData = { label: 'SMA', value: 'SeniorHighSchool' }
      break
    case 'VocationalHighSchool':
      definedData = { label: 'SMK', value: 'VocationalHighSchool' }
      break
    case 'Diploma1':
      definedData = { label: 'D1', value: 'Diploma1' }
      break
    case 'Diploma2':
      definedData = { label: 'D2', value: 'Diploma2' }
      break
    case 'Diploma3':
      definedData = { label: 'D3', value: 'Diploma3' }
      break
    case 'Diploma4':
      definedData = { label: 'D4', value: 'Diploma4' }
      break
    case 'Bachelor':
      definedData = { label: 'S1', value: 'Bachelor' }
      break
    case 'Master':
      definedData = { label: 'S2', value: 'Master' }
      break
    case 'Doctorate':
      definedData = { label: 'S3', value: 'Doctorate' }
      break
    case 'Other':
      definedData = { label: 'Lain-lain', value: 'Other' }
      break
    default:
      break
  }

  return definedData
}

export default LastEducationDefiner